const ACCESS_TOKEN_KEY = 'parent_access_token';
const REFRESH_TOKEN_KEY = 'parent_refresh_token';
const USER_KEY = 'parent_user';

const readJSON = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const emitAuthChange = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event('parent-auth-changed'));
};

export const getParentAuthState = () => ({
  accessToken: localStorage.getItem(ACCESS_TOKEN_KEY),
  refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY),
  user: readJSON(localStorage.getItem(USER_KEY)),
});

export const saveParentAuth = ({ access_token, refresh_token, user }) => {
  if (access_token) localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
  if (refresh_token) localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  else localStorage.removeItem(USER_KEY);
  emitAuthChange();
};

export const clearParentAuth = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  emitAuthChange();
};

export const getParentAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const getParentRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
